import {useQuery} from '@tanstack/react-query';
import {API} from '@chekin/api';
import {QUERY_CACHE_KEYS} from '@chekin/core';

type Props = {
  id?: string;
  enabled?: boolean;
};
export const useFetchAddonMultiPayment = ({id, enabled = true}: Props) => {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.addonMultiPayment, id],
    queryFn: () => API.payments.getAddonMultiPayment(id ?? ''),
    enabled: Boolean(id && enabled),
    refetchOnWindowFocus: false,
  });
};
